import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as BannerComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import DEFINE, { FEATURE_FLAGS, TRANSLATE_LANGUAGE } from "../../../../constants/Define";
import Image from '../../common/component/Image';
import * as ANT from 'antd';
import './Banners.less';
import { FlagIcons } from '../../common/component/TranslateButton';
import Wrapper from '../../common/component/Wrapper';
import { toArray } from 'lodash';
import EllipsisText from '../../common/component/EllipsisText';

let permisionActions = [];
class Banners extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.BannersModel.titleTable, ['action'], ['id']),
        modelBanner: Model.BannersModel.titleTable,
        viewResetPassword: false,
        componentTable: {
            name: {
                key: "name",
                sorter: (i, k) => i.name.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                        handleSearch={this.handleSearch}
                        handleReset={this.handleReset}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            url: {
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            order: {
                sorter: (i, k) => i.order.length - k.length,
            },
            imageView: {
                width: 200,
                render: (view, record) => (
                    <Image src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${view.fileUrl || view.fileUri}`} hasViewer={true} width="100%" wrapperStyle={{ position: 'relative' }} />
                )
            },
            translations: {
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
                width: 120,
                render: (text, record) => <FlagIcons languages={record.translations} />,
            },
            isEnabled: {
                key: 'isEnabled',
                render: (isEnabled) => <HMS.StatusComponent color={isEnabled ? 'green' : 'red'}
                    label={isEnabled ? i18n.t('item.banner.active') : i18n.t('item.banner.deActive')} />,
                filters: [
                    { value: true, text: this.props.t(`item.banner.active`) },
                    { value: false, text: this.props.t(`item.banner.deActive`) },
                ],
                filterMultiple: false,

            },
            action: {
                align: 'center',
                render: (text, record) => <BannerComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteBanner={this.props.onDeleteBanner} />,
            }
        },
        banners: [],
        pageSize: this.props.banners.data.pageSize,
        pageIndex: this.props.banners.data.pageIndex,
        totalCount: this.props.banners.data.totalCount,
        totalPage: this.props.banners.data.totalPage,
        isFetching: false,
        isExport: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BANNER);
        this.setState({
            pageSize: this.props.banners.data.pageSize,
            pageIndex: this.props.banners.data.pageIndex,
            totalCount: this.props.banners.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.banners.data.totalCount) / parseInt(this.props.banners.data.pageSize))
        })
        this.props.onListBanner({ pageSize: this.props.banners.data.pageSize, pageIndex: this.props.banners.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.banners.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.banners.data !== prevProps.banners.data) {
            this.setState({
                banners: this.props.banners.data.result,
                pageSize: this.props.banners.data.pageSize,
                pageIndex: this.props.banners.data.pageIndex,
                totalCount: this.props.banners.data.totalCount,
                totalPage: this.props.banners.data.totalCount / this.props.banners.data.pageSize,
            })
        }
    }

    onChangeLanguage = (language) => {
        this.props.onListBanner({ pageSize: this.props.banners.data.pageSize, pageIndex: this.props.banners.data.pageIndex });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListBanner(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, banners, modelBanner, isFetching, totalCount, componentTable, pageSize, pageIndex } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'banners'}
                        titleHeader={t('navigation.banners')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={`/banners/action`} className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="banner-list"
                        classParent="list-banners m-0"
                        classChildren="p-0"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(banners, modelBanner)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'banner'
                        })}
                        onChange={this.onChange} pagination={{ total: totalCount, totalPage: totalPage, pageSize, current: pageIndex }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <Link to={`/banners/action`} className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        banners: state.bannerReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListBanner: (filters) => {
            dispatch(action.dataBannerAction(filters))
        },
        onDeleteBanner: (id) => {
            dispatch(action.deleteBannerAction(id))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Banners));
